require('../../modules/es6.math.sign');
module.exports = require('../../modules/_core').Math.sign;



//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/core-js/library/fn/math/sign.js
// module id = 792
// module chunks = 1